<template>
  <div class="hot-container">
    <header>
      <span class="title">热门应用</span>
      <div class="right">
        <span>适用行业</span>
        <el-select v-model="industry" placeholder="请选择" size="medium" @change="selectChange">
          <el-option v-for="item in option1" :key="item.id" :label="languageFilter(item.classify_name)" :value="item.id"></el-option>
        </el-select>
        <span>功能分类</span>
        <el-select v-model="classification" placeholder="请选择" size="medium" @change="selectChange">
          <el-option v-for="item in option2" :key="item.id" :label="languageFilter(item.classify_name)" :value="item.id"></el-option>
        </el-select>
        <el-button :disabled="disabled" @click="applyManage(1)" v-if="funAuth.includes(36)">删  除</el-button>
        <el-button :disabled="disabled" type="primary" @click="applyManage(0)" v-if="funAuth.includes(34)">排 序</el-button>
        <el-button type="primary" :disabled="disabled" @click="versionSetting">可安装版本设置</el-button>
      </div>
      <div class="tab-box">
        <div class="tab-item" :class="(charge_type == 0) ? 'active':''" @click="handleClick(0)">免费应用</div>
        <div class="tab-item" :class="(charge_type == 1) ? 'active':''" @click="handleClick(1)">付费应用</div>
      </div>
    </header>
    <el-table ref='multipleTable' :data='tableList' tooltip-effect='dark' style='width: 100%' @row-click="audit" @selection-change='handleSelectionChange' class="el-table-01">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop='order_index' label='序号' width='80'></el-table-column>
      <el-table-column label='名称'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle">{{scope.row.template_name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='version' label='版本号'></el-table-column>
      <el-table-column  label='介绍'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle">{{scope.row.introduce}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='fit_industry' label='应用类型'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle" v-text="classifyInfo(scope.row.classifyInfo, 1)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='func_type' label='所属行业'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle" v-text="classifyInfo(scope.row.classifyInfo, 2)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='charge_type' label='类型'></el-table-column>
      <el-table-column prop='download_number' label='安装次数'></el-table-column>
      <el-table-column prop='upload_user' label='开发者'></el-table-column>
      <el-table-column prop='user_name' label='审核人'></el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <el-dialog title="排序" :visible.sync="dialogQuality" class="dialog-manage">
      <span class="title">序号</span>
      <div class="right">
        <el-input v-model="inputNum" placeholder="请输入" size="medium" type="number"></el-input>
        <div class="note">序号越小，前台显示越靠前</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogQuality = false">取 消</el-button>
        <el-button type="primary" @click="sort">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogRemove" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">提示：移出后该应用将不再显示在精品应用中，所有用户仍可以通过应用中心安装此应用。</div>
      <div class="prompt">您确认要移除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRemove = false">取 消</el-button>
        <el-button type="primary" @click="applyRemove">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="可安装版本设置" :visible.sync="versionSetDialog" class="version-setting">
      <p class="hintContent">请设置哪些客户的版本可以安装此应用，功能版本和组件皆符合才可以安装。</p>
      <p style="line-height: 30px;">上传客户当前版本：旗舰版（功能版本）、全组件（组件版本）</p>
      <p class="title">哪些客户可安装此应用，功能版本为以下版本即可（多选）：</p>
      <p>
        <el-select multiple collapse-tags v-model="version" placeholder="请选择(必填)" size="medium">
          <el-option v-for="item in vOptions" :key="item.id" :label="item.version_name" :value="item.id"></el-option>
        </el-select>
      </p>
      <p class="title">哪些客户可安装此应用，组件版本为以下版本即可（多选）：</p>
      <p>
          <el-select multiple collapse-tags v-model="field_typesId" placeholder="请选择(必填)" size="medium">
            <el-option v-for="item in componentData" :key="item.id" :label="item.cm_name" :value="item.id"></el-option>
          </el-select>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="versionSetDialog = false">取 消</el-button>
        <el-button type="primary" @click="versionSet">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import {appIndustry, regular} from '@/common/js/constant.js'
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>热门应用</b>',
      ellipsisStyle: '-webkit-line-clamp: 5;-webkit-box-orient: vertical;',
      searchInput: '',
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      disabled: true,
      activeName: 'first',
      options1: [
        {id: '0', label: '免费'},
        {id: '1', label: '付费'}
      ],
      charge_type: 0,
      industry: '',
      classification: '',
      option1: [],
      option2: [],
      inputNum: '',
      dialogQuality: false,
      dialogRemove: false,
      versionSetDialog: false,
      vOptions: [],
      version: [], // 功能版本
      componentData: [],
      field_typesId: [] // 组件版本
    }
  },
  mixins: [mixin],
  mounted () {
    this.charge_type = this.$route.query.tab || 0
    this.queryNonsuchApplicationList()
    this.queryFchBtnAuth(({moduleId: 10}))
    this.appClassifyList()
  },
  methods: {
    /** 获取应用分类 */
    appClassifyList () {
      HTTPServer.appClassifyList({classifyType: ''}, 'Loading').then((res) => {
        this.option1 = []
        this.option2 = []
        res.map(v => {
          if (v.classify_type === 1) {
            this.option2.push(v)
          } else if (v.classify_type === 2) {
            this.option1.push(v)
          }
        })
      })
    },
    /** 获取注册客户 */
    queryNonsuchApplicationList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'charge_type': this.charge_type, 'keyWord': this.searchValue, 'fit_industry': this.industry, 'func_type': this.classification}
      HTTPServer.queryNonsuchApplicationList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        for (var i = 0; i < this.tableList.length; i++) {
          for (var j = 0; j < appIndustry.industry.length; j++) {
            if (this.tableList[i].fit_industry === appIndustry.industry[j].id) {
              this.tableList[i].fit_industry = appIndustry.industry[j].label
            }
          }
          for (var k = 0; k < appIndustry.classification.length; k++) {
            if (this.tableList[i].func_type === appIndustry.classification[k].id) {
              this.tableList[i].func_type = appIndustry.classification[k].label
            }
          }
          for (var s = 0; s < this.options1.length; s++) {
            if (this.tableList[i].charge_type.toString() === this.options1[s].id) {
              this.tableList[i].charge_type = this.options1[s].label
            }
          }
        }
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 搜索 */
    selectChange () {
      this.queryNonsuchApplicationList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryNonsuchApplicationList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryNonsuchApplicationList()
    },
    // 行的点击事件
    audit (val) {
      this.$router.push({name: 'ApplyDetail', query: {'id': val.id}, params: {detail: 4}})
    },
    handleClick (tab) {
      this.charge_type = tab
      this.pageNum = 1
      this.pageSize = 20
      this.queryNonsuchApplicationList()
      this.$router.push({name: 'HotApply', query: {tab: tab}})
    },
    applyManage (type) {
      if (this.multipleSelection.length > 1 && type !== 1) {
        this.$message.error('只能选择一条数据')
        return
      }
      if (type === 0) { // 排序
        this.dialogQuality = true
        this.inputNum = ''
      } else if (type === 1) { // 移出应用
        this.dialogRemove = true
      }
    },
    /** 排序 */
    sort () {
      if (!this.inputNum) {
        this.$message.error('序号不能为空')
        return
      }
      if (!regular.positiveInteger.test(this.inputNum)) {
        this.$message.error('序号格式错误')
        return
      }
      var jsondata = {'id': this.multipleSelection[0].id, 'order': this.inputNum}
      HTTPServer.editNonsuchApplication(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.queryNonsuchApplicationList()
        this.dialogQuality = false
      })
    },
    /** 移出应用 */
    applyRemove () {
      var id = []
      for (var i = 0; i < this.multipleSelection.length; i++) {
        id.push(this.multipleSelection[i].id)
      }
      var jsondata = {'id': id.toString()}
      HTTPServer.removeNonsuchApplication(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.queryNonsuchApplicationList()
        this.dialogRemove = false
      })
    },
    versionSetting () {
      // if (this.multipleSelection.length > 1) {
      //   this.$message({
      //     showClose: true,
      //     message: '每次仅可对一个应用进行设置，不支持批量',
      //     type: 'error'
      //   })
      //   return
      // }
      this.version = []
      this.field_typesId = []
      if (this.multipleSelection.length === 1) {
        let data = JSON.parse(JSON.stringify(this.multipleSelection[0]))
        if (data.fc_id) {
          data.fc_id.split(',').map(item => {
            this.version.push(parseInt(item))
          })
        }
        if (data.cm_id) {
          data.cm_id.split(',').map(item => {
            this.field_typesId.push(parseInt(item))
          })
        }
      }
      this.versionSetDialog = true
      this.queryAllChargingStrategy()
      this.getEnableComponentManageList()
    },
    /** 获取 组件管理 */
    getEnableComponentManageList (id) {
      HTTPServer.getEnableComponentManageList({}, 'Loading').then((res) => {
        this.componentData = res
      })
    },
    versionSet () {
      if (this.version.length === 0) {
        this.$message({
          showClose: true,
          message: '功能版本不能为空!',
          type: 'error'
        })
        return
      }
      if (this.field_typesId.length === 0) {
        this.$message({
          showClose: true,
          message: '组件版本不能为空!',
          type: 'error'
        })
        return
      }
      let ids = []
      this.multipleSelection.map(v => {
        ids.push(v.id)
      })
      let jsondata = {'id': ids.toString(), 'fc_id': this.version.toString(), 'cm_id': this.field_typesId.toString()}
      console.log(jsondata)
      HTTPServer.updateApplicationVersion(jsondata, 'Loading').then((res) => {
        this.componentData = res
        this.queryNonsuchApplicationList()
        this.versionSetDialog = false
      })
    },
    classifyInfo (arr, type) {
      var text = []
      arr.map(v => {
        if (v.classify_type === type) {
          text.push(this.languageFilter(v.classify_name))
        }
      })
      return text.toString()
    },
    // 语言过滤
    languageFilter (name) {
      if (JSON.stringify(name).includes('{\\"language\\"')) {
        if (typeof name === 'string') {
          return JSON.parse(name).language.zh
        } else {
          return name.language.zh
        }
      } else {
        return name
      }
    }
  }
}
</script>

<style lang="scss">
.hot-container{
  header{
    height: auto!important;
    .right{
      >span{
        margin: 0 12px;
      }
    }
    .tab-box{
      overflow: hidden;
      margin: 0 0 -1px 0;
      .tab-item{
        display: inline-block;
        float: left;
        width: 88px;
        height: 39px;
        text-align: center;
        line-height: 40px;
        background: #fff;
        border: 1px solid rgba(0,0,0,0.15);
        border-radius: 4px 4px 0 0;
        margin-right: 4px;
        border-bottom: none;
        cursor: pointer;
      }
      .tab-item.active{
        height: 40px;
        background: #FAFAFA;
        color: #0062B1;
        border: 1px solid #0062B1;
        border-bottom: 1px solid transparent;
      }
    }
  }
  .el-table{
    height: calc(100% - 160px);
  }
  .dialog-manage{
    .el-dialog{
      width: 500px;
    }
    .el-dialog__header{
      padding: 13px 20px;
      box-shadow: inset 0 -1px 0 0 #E5E5E5;
    }
    .el-dialog__headerbtn{
      top: 14px;
      .el-dialog__close{
        font-size: 24px;
      }
    }
    .el-dialog__body{
      padding: 30px 20px 28px;
      min-height: 120px;
      .title{
        float: left;
        width: 80px;
        text-align: right;
        padding-right: 14px;
        line-height: 36px;
        font-size: 14px;
        color: #666;
      }
      .right{
        width: calc(100% - 100px);
        display: inline-block;
      }
      .note{
        font-size: 12px;
        color: #FF1717;
        margin-top: 10px;
      }
    }
    .el-dialog__footer{
      padding: 10px 20px;
      box-shadow: inset 0 1px 0 0 #E5E5E5;
      .el-button{
        padding: 8px 16px;
      }
    }
  }
  .version-setting{
    .el-dialog{
      width: 600px;
    }
    .el-dialog__header{
      padding: 13px 20px;
      box-shadow: inset 0 -1px 0 0 #E5E5E5;
    }
    .el-dialog__body{
      padding: 20px 30px;
      p{
        line-height: 40px;
      }
      .hintContent{

      }
      .el-select{
        width: 88%;
      }
    }
    .el-dialog__footer{
      padding: 10px 20px;
      box-shadow: inset 0 1px 0 0 #E5E5E5;
      .el-button{
        padding: 8px 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/application/hot-apply.vue